import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Tone = 'neutral' | 'brand' | 'accent' | 'success' | 'warning' | 'destructive';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  leftIcon?: ReactNode;
}

const tones: Record<Tone, string> = {
  neutral: 'bg-tg-section-bg text-tg-text',
  brand: 'bg-brand-muted text-brand',
  accent: 'bg-accent/12 text-accent',
  success: 'bg-success-subtle text-success',
  warning: 'bg-warning-subtle text-warning',
  destructive: 'bg-destructive-subtle text-destructive',
};

export function Badge({ tone = 'neutral', leftIcon, className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium',
        tones[tone],
        className,
      )}
      {...rest}
    >
      {leftIcon}
      {children}
    </span>
  );
}
